/**
 * Adds support for optional services - when sending a proposal services can be optional,
 * and the client can choose to include/exclude them.
 */

/** This is how the service is saved in the DB. */

export let ServiceStatusType = /*#__PURE__*/function (ServiceStatusType) {
  ServiceStatusType["AwaitingApproval"] = "awaitingApproval";
  ServiceStatusType["Approved"] = "approved";
  ServiceStatusType["Amended"] = "amended";
  ServiceStatusType["Completed"] = "completed";
  ServiceStatusType["Terminated"] = "terminated";
  ServiceStatusType["Canceled"] = "canceled";
  return ServiceStatusType;
}({});
export let ServiceCostType = /*#__PURE__*/function (ServiceCostType) {
  ServiceCostType["Fixed"] = "fixed";
  ServiceCostType["Variable"] = "variable";
  ServiceCostType["Range"] = "range";
  return ServiceCostType;
}({});
export let RecurrencePeriodTypes = /*#__PURE__*/function (RecurrencePeriodTypes) {
  RecurrencePeriodTypes["Weekly"] = "weekly";
  RecurrencePeriodTypes["BiWeekly"] = "biweekly";
  RecurrencePeriodTypes["Monthly"] = "monthly";
  RecurrencePeriodTypes["Quarterly"] = "quarterly";
  RecurrencePeriodTypes["Yearly"] = "yearly";
  return RecurrencePeriodTypes;
}({});
export let ServiceChangeItemType = /*#__PURE__*/function (ServiceChangeItemType) {
  ServiceChangeItemType["Pricing"] = "pricing";
  ServiceChangeItemType["Discount"] = "discount";
  ServiceChangeItemType["BillingTrigger"] = "billingTrigger";
  ServiceChangeItemType["Description"] = "description";
  ServiceChangeItemType["PriceIncrease"] = "priceIncrease";
  return ServiceChangeItemType;
}({});

/** Any change in price, pricingType, unitCap, unitName */